var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDashboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.5,
    height: 16.5,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0CFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.887 14.457c-.112.162-.339.293-.653.293H3.766c-.314 0-.541-.131-.653-.293C2.257 13.22 1.75 11.7 1.75 10.05 1.75 5.846 5.03 2.5 9 2.5s7.25 3.346 7.25 7.55c0 1.65-.507 3.17-1.363 4.407z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.75,
    r: 1.5,
    fill: "#D0CFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0CFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 9.461L11.298 7.163"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.86b8707b.svg";
export { ForwardRef as ReactComponent };